import {atom} from "jotai";

export const eventStatusAtom = atom([
    {
        status_id: 1,
        name: "Scheduled",
        status_type_id: 1,
        status_type: "TimeLine",
        style: "tl-scheduled",
    },
    {
        status_id: 2,
        name: "Completed",
        status_type: "TimeLine",
        style: "tl-completed",
    },
    {
        status_id: 3,
        name: "In Progress",
        status_type: "TimeLine",
        style: "tl-in-progress",
    },
    {
        status_id: 4,
        name: "Needs Action",
        status_type: "TimeLine",
        style: "tl-failed",
    },
    {
        status_id: 5,
        name: "Blocked Time",
        status_type: "TimeLine",
        style: "tl-other",
    },
    {
        status_id: 6,
        name: "Time Off",
        status_type: "TimeLine",
        style: "tl-time-off",
    },
    {
        status_id: 7,
        name: "En Route",
        status_type: "TimeLine",
        style: "tl-en-route",
    },
    {
        status_id: 8,
        name: "Needs Remote Activation",
        status_type: "TimeLine",
        style: "tl-remote-activation",
    },
]);